import checkIfNonCircularRangesOverlap from "./checkIfNonCircularRangesOverlap";
import splitRangeIntoTwoPartsIfItIsCircular from "./splitRangeIntoTwoPartsIfItIsCircular";
export default function checkIfPotentiallyCircularRangesOverlap(range, comparisonRange) {
  return splitRangeIntoTwoPartsIfItIsCircular(range, Infinity).some(
    function(splitRange) {
      return splitRangeIntoTwoPartsIfItIsCircular(
        comparisonRange,
        Infinity
      ).some(function(splitComparisonRange) {
        return checkIfNonCircularRangesOverlap(
          splitRange,
          splitComparisonRange
        );
      });
    }
  );
}
